import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Groupper, Header, Icon, Input, Message } from 'react-frontier';
import { useSearchParams } from 'react-router-dom';
import API, { CDN_URL } from '../AuthAPI';
import { bindFormChange } from '@arema/components/Util';
import { SetLoading } from '@arema/components/Classes';
import Validator from '@arema/components/Validator';

interface UserInfo{
	user_id: number,
	first_name: string,
	last_name: string,
	strong_password: boolean,
}

var PasswordComplete = ()=>{
	var { t } = useTranslation();
	var [params] = useSearchParams();
	var [user, setUser] = useState<UserInfo>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);
	var [completed, setCompleted] = useState<boolean>(false);
	var [formData, setFormData] = useState<{
		password: string,
		repeat_password: string
	}>({
		password: '',
		repeat_password: ''
	});

	var password_token = useMemo(()=>{
		if(!params) return null;
		var token = params.get('pt');
		if(!token || token.length<10) return null;
		return token;
	}, [params]);

	useEffect(()=>{
		if(!password_token || user) return;
		API.getUserCompleteInfo(password_token).then(res=>{
			if(res.error) return setLoadError(res.message);
			setUser(res.data);
		}).catch(err=>{
			setLoadError('Hubo un error inesperado cargando la información del usuario (LCL-ATHPWCPL-1)');
		})
	}, [password_token]);

	var sendPassword = (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(formData, {
			password: [
				{ rule: 'password', label: 'Contraseña' }
			],
			repeat_password: [
				{ rule: 'matches', params: ['password'], label: 'Repetir contraseña' }
			]
		});

		setErrorPrompts(prompts);
		if(!valid) return;
		setLoading(true);
		API.recoverPassword(password_token, formData.password).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			setCompleted(true);
		}).catch(err=>{
			setErrorPrompts(['Hubo un errpr inesperado enviando la información (LCL-ATHPWCPL-2)']);
		})
	}

	var onFormChange = bindFormChange(formData, setFormData);
	
	return <div className={"ar login-screen"}>
		<img className='ar logo' src={`${CDN_URL}/logo/LogoH_Large.webp`} alt="AREMA" />	
		<Groupper defaultStyle={false} actions={null}>
			<div className="head">
				<Header centered text={'Completar cuenta'} />
			</div>
			{(!password_token || loadError) ? (
				<div className="contents full" style={{ marginTop: -20 }}>
					<Header text={loadError ? 'Error' : 'Solicitud inválida'} subtext={loadError || 'El token de autenticación es inválido'} />
				</div>
			) : !user ? (
				<div className="contents full" style={{ marginTop: -20 }}>
					<Header text={"Cargando datos"} subtext={'Un segundo mientras cargamos tu información'} subheaderStyle={{ fontSize: 14 }} style={{ paddingTop: 0 }} loading />
				</div>
			) : completed ? (
				<div className="contents full" style={{ flexDirection: 'column', marginTop: -20 }}>
					<Icon name='circle-check' size={80} style={{ lineHeight: '80px', marginBottom: 10, marginRight: 0, textAlign: 'center', color: 'green' }} />
					<Header text={'Cuenta completada'} subtext={'Se ha completado la creación de la cuenta'} />
				</div>
			) : <>
				<div className="contents">
					<Message type='info' header={`¡Hola, ${user.first_name}!`} centered style={{ marginBottom: 15 }}>
						En seguida podrás ingresar tu nueva contraseña para ingresar a los sistemas de AREMA.
						{!!user.strong_password && <>
							<br />
							Debido a nuestros requerimientos de seguridad, la contraseña debe de ser de minimo <b>8 caracteres</b> y debe de tener por lo menos: 
							<br />
							<b>1 número, 1 letra mayúscula, 1 letra minúscula y 1 caracter especial (!@#$%^&*.,+)</b>
						</>}
					</Message>
					<Input label='Nueva contraseña' value={formData.password} onChange={onFormChange('password')} inputType='password' />
					<Input label='Repetir contraseña' value={formData.repeat_password} onChange={onFormChange('repeat_password')} inputType='password' />
					<Message type='error' list={errorPrompts} />
				</div>
				<div className="actions">
					<Button text='Guardar' color='black' onClick={sendPassword} />
				</div>
			</>}
		</Groupper>
	</div>
}

export default PasswordComplete;